import { Button } from "@app/scripts/react-general-components/Button"
import { ResultPaginationLoadMoreProps } from "@usereactify/search"
import React, { useMemo } from "react"
import { useInView } from "react-intersection-observer"

type PaginationLoadMoreProps = React.ComponentProps<
  NonNullable<ResultPaginationLoadMoreProps["render"]>
> & {
  pageSize: number;
}

export const PaginationLoadMore: React.FC<PaginationLoadMoreProps> = (props) => {
  const { ref, inView } = useInView({
    rootMargin: "800px",
    threshold: 0,
  });

  const barPercentage = useMemo(
    () => props.resultStats?.displayedResults && props.resultStats?.numberOfResults ?
      props.resultStats.displayedResults / props.resultStats.numberOfResults * 100 :
      0
  , [props.resultStats?.displayedResults, props.resultStats?.numberOfResults])

  // NOTE: Enable this to load more products on the first page
  // const isSecondPage = useMemo(
  //   () => props.resultStats?.displayedResults && props.resultStats.displayedResults > props.pageSize && props.resultStats.displayedResults <= props.pageSize * 2
  // , [props.resultStats?.displayedResults, props.resultStats?.numberOfResults]);
  // useEffect(() => {
  //   if (inView && props.hasMore && !isSecondPage) props.handleLoadMore();
  // }, [inView]);

  const loadAll = () => {
    if (props.resultStats?.numberOfResults === undefined) return;

    const remainingResults = props.resultStats?.numberOfResults - props.resultStats?.displayedResults;
    const totalPages = Math.ceil(remainingResults / props.pageSize);
    for (let i = 0; i < totalPages; i++) {
      setTimeout(() => {
        props.handleLoadMore();
      }, 1000 * i);
    }
  };

  return (
    <div ref={ref} className="main-collection-product-grid__loadmore">
      {`Showing ${props.resultStats?.displayedResults} of ${props.resultStats?.numberOfResults} products`}

      <svg
        preserveAspectRatio="none"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 100 5"
        className="main-collection-product-grid__loadmore-bar"
      >
        <rect x="0%" y="0%" width={barPercentage+"%"} height="5" fill="#000" />
      </svg>

      {props.hasMore && (
        <>
          <Button
            className="main-collection-product-grid__loadmore-button"
            onClick={props.handleLoadMore}
            disabled={!props.hasMore}
            label={"Load More"}
            variant="secondary"
          />
          <Button
            className="main-collection-product-grid__loadmore-button"
            onClick={loadAll}
            disabled={!props.hasMore}
            label={"Load all products"}
            variant="text"
          />
        </>
      )}
    </div>
  );
}
